(function ($) {
	$(function () {
/*
		var $form = $('.form_requestForm'),
			$slides = $form.find('.swiper-slide');

		if ($form) {
			//$('.form__label.phone input').mask('+7 (999) 999-99-99');

			$('.datepicker').datepicker({
				showAnim: 'fade'
			});

			// --- selectric ----
			var $select = $('.form__select');

			$select.selectric({
				arrowButtonMarkup: '<svg class="selectric-select__arrow" width="16" height="8"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#down-arrow"></use></svg>'
			});
			$select.on('selectric-open', function(event, element, selectric) {
				$(element)
					.parents('.selectric-wrapper')
					.find('.selectric-select__arrow')
					.addClass('selectric-select__arrow--open');
			});
			$select.on('selectric-close', function(event, element, selectric) {
				$(element)
					.parents('.selectric-wrapper')
					.find('.selectric-select__arrow')
					.removeClass('selectric-select__arrow--open');
			});

			/!*var swiper = new Swiper($form.find('.swiper-container'), {
				effect: 'fade',
				nextButton: $form.find('.swiper-button-next'),
				prevButton: $form.find('.swiper-button-prev'),
				simulateTouch: false,
				keyboard: true
			});*!/

			$.each($slides, function(){
				//$(this).mCustomScrollbar();
			});
		}
*/
	});
})(jQuery);